
[
  {
    "id": "TG-E8P-L306-001",
    "module": "TijdGeld",
    "difficulty": 306,
    "question": "Hypotheekrenteaftrek: Je betaalt € 10.000 rente. Je mag 40% aftrekken. Je belastingtarief is 50%. Wat is je voordeel?",
    "options": ["€ 2.000", "€ 4.000", "€ 5.000", "€ 1.000"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "btw",
    "familyId": "TG-HYPOTHEEK",
    "explanation": "Aftrekpost: 4000. Voordeel: 50% van 4000 = 2000.",
    "distractorExplanations": { "1": "Dat is de aftrekpost.", "2": "Dat is 50% van de rente.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-E8P-L306-002",
    "module": "TijdGeld",
    "difficulty": 306,
    "question": "Hoeveel nanoseconden in 1 seconde?",
    "options": ["1 miljard", "1 miljoen", "1000", "1 biljoen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tijdrekenen",
    "subSkill": "tijd_omrekenen",
    "familyId": "TG-NANO",
    "explanation": "Nano = miljardste (10^-9). Dus 1 miljard.",
    "distractorExplanations": { "1": "Dat is micro.", "2": "Dat is milli.", "3": "Dat is pico." }
  },
  {
    "id": "TG-E8P-L306-003",
    "module": "TijdGeld",
    "difficulty": 306,
    "question": "Bitcoin stijgt van 20.000 naar 25.000. Hoeveel procent rendement?",
    "options": ["25%", "20%", "5%", "125%"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-CRYPTO",
    "explanation": "Winst 5000. 5000/20000 = 1/4 = 25%.",
    "distractorExplanations": { "1": "Dat is 5000/25000.", "2": "Absoluut verschil x 1000.", "3": "Nieuwe waarde t.o.v. oude." }
  },
  {
    "id": "TG-E8P-L306-004",
    "module": "TijdGeld",
    "difficulty": 306,
    "question": "Je rijdt 100 km met 50 km/u en 100 km met 100 km/u. Wat is je gemiddelde snelheid?",
    "options": ["66,6 km/u", "75 km/u", "80 km/u", "60 km/u"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "snelheid",
    "subSkill": "snelheid_berekenen",
    "familyId": "TG-GEM-SNELHEID",
    "explanation": "Deel 1: 2 uur. Deel 2: 1 uur. Totaal 3 uur over 200 km. 200/3 = 66,6.",
    "distractorExplanations": { "1": "Gemiddelde van de snelheden (fout!).", "2": "Schattingsfout.", "3": "Schattingsfout." }
  },
  {
    "id": "TG-E8P-L306-005",
    "module": "TijdGeld",
    "difficulty": 306,
    "question": "Wat is de contante waarde van € 110 over een jaar bij 10% rente?",
    "options": ["€ 100", "€ 99", "€ 101", "€ 90"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "financieel",
    "subSkill": "rente",
    "familyId": "TG-CW",
    "explanation": "100 x 1,10 = 110. Dus 100.",
    "distractorExplanations": { "1": "110 - 10% = 99.", "2": "Schattingsfout.", "3": "Schattingsfout." }
  }
]
